declare namespace $ {

	type $bog_ui_breadcrumb__crumbs_bog_wikilive_page_1 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['breadcrumb_ids'] >
		,
		ReturnType< $bog_ui_breadcrumb['crumbs'] >
	>
	type $bog_ui_breadcrumb__crumb_title_bog_wikilive_page_2 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['breadcrumb_title'] >
		,
		ReturnType< $bog_ui_breadcrumb['crumb_title'] >
	>
	type $bog_ui_breadcrumb__crumb_uri_bog_wikilive_page_3 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['breadcrumb_uri'] >
		,
		ReturnType< $bog_ui_breadcrumb['crumb_uri'] >
	>
	type $bog_ui_breadcrumb__last_title_bog_wikilive_page_4 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['page_title'] >
		,
		ReturnType< $bog_ui_breadcrumb['last_title'] >
	>
	type $mol_string_button__value_bog_wikilive_page_5 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['page_title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__hint_bog_wikilive_page_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_view__sub_bog_wikilive_page_7 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['editor_avatars'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_icon__checked_bog_wikilive_page_8 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['is_favorite'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_bog_wikilive_page_9 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['Fav_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_bog_wikilive_page_10 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['editing'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_bog_wikilive_page_11 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['Edit_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_button_minor__hint_bog_wikilive_page_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_wikilive_page_13 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['table_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_wikilive_page_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_wikilive_page_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_wikilive_page_16 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['history_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_wikilive_page_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_wikilive_page_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_wikilive_page_19 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['child_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_wikilive_page_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_download__hint_bog_wikilive_page_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['hint'] >
	>
	type $mol_button_download__file_name_bog_wikilive_page_22 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['export_filename'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__uri_bog_wikilive_page_23 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['export_uri'] >
		,
		ReturnType< $mol_button_download['uri'] >
	>
	type $mol_button_minor__hint_bog_wikilive_page_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_wikilive_page_25 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['page_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_wikilive_page_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_wikilive_page_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_wikilive_page_28 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['history_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_wikilive_page_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_avatar__id_bog_wikilive_page_30 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['history_entry_peer'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_view__sub_bog_wikilive_page_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_wikilive_page_32 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['content'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_textarea__value_bog_wikilive_page_33 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['content'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_bog_wikilive_page_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $bog_wikilive_table_view__table_bog_wikilive_page_35 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['table_entity'] >
		,
		ReturnType< $bog_wikilive_table_view['table'] >
	>
	type $mol_avatar__id_bog_wikilive_page_36 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['editor_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $bog_ui_sheet__side_bog_wikilive_page_37 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sheet['side'] >
	>
	type $bog_ui_sheet__showed_bog_wikilive_page_38 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['history_showed'] >
		,
		ReturnType< $bog_ui_sheet['showed'] >
	>
	type $bog_ui_sheet__content_bog_wikilive_page_39 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['history_content'] >
		,
		ReturnType< $bog_ui_sheet['content'] >
	>
	type $mol_view__sub_bog_wikilive_page_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_wikilive_page_41 = $mol_type_enforce<
		ReturnType< $bog_wikilive_page['history_items'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_wikilive_page_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_wikilive_page extends $mol_page {
		page_title( next?: string ): string
		breadcrumb_ids( ): readonly(any)[]
		breadcrumb_title( id: any): string
		breadcrumb_uri( id: any): string
		Breadcrumb( ): $bog_ui_breadcrumb
		Title_edit( ): $mol_string_button
		editor_avatars( ): readonly(any)[]
		Editors( ): $mol_view
		is_favorite( next?: boolean ): boolean
		Fav_icon( ): $mol_icon_star
		Fav_toggle( ): $mol_check_icon
		editing( next?: boolean ): boolean
		Edit_icon( ): $mol_icon_pencil
		Edit_toggle( ): $mol_check_icon
		table_add( next?: any ): any
		Table_icon( ): $mol_icon_table
		Add_table( ): $mol_button_minor
		history_toggle( next?: any ): any
		History_icon( ): $mol_icon_history
		History_toggle( ): $mol_button_minor
		child_add( next?: any ): any
		Add_icon( ): $mol_icon_plus
		Add_child( ): $mol_button_minor
		export_filename( ): string
		export_uri( ): string
		Export( ): $mol_button_download
		page_delete( next?: any ): any
		Delete_icon( ): $mol_icon_delete
		Delete( ): $mol_button_minor
		body_content( ): readonly(any)[]
		content( next?: string ): string
		table_entity( id: any): $bog_wikilive_table
		editor_id( id: any): string
		history_showed( next?: boolean ): boolean
		history_content( ): readonly(any)[]
		History_title( ): $mol_view
		history_close( next?: any ): any
		History_close_icon( ): $mol_icon_close
		History_close( ): $mol_button_minor
		history_items( ): readonly(any)[]
		history_entry_peer( id: any): string
		History_entry_avatar( id: any): $mol_avatar
		history_entry_time( id: any): string
		history_entry_changes( id: any): string
		History_entry_info( id: any): $mol_view
		store( ): $bog_wikilive_store
		page_link( ): string
		title( ): ReturnType< $bog_wikilive_page['page_title'] >
		head( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): ReturnType< $bog_wikilive_page['body_content'] >
		View( ): $mol_text
		Editor( ): $mol_textarea
		Table_view( id: any): $bog_wikilive_table_view
		Editor_avatar( id: any): $mol_avatar
		History( ): $bog_ui_sheet
		History_header( ): $mol_view
		History_list( ): $mol_list
		History_entry( id: any): $mol_view
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map